export const ROOT = "/admin/dashboard";
